exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__FIeld__root {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n  .DS__FIeld__root {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n  .DS__FIeld__root .DS__FIeld__underline {\n    position: absolute;\n    right: 0;\n    bottom: -3px;\n    left: 0;\n    display: block;\n    height: 1px;\n    background-color: #dde3ed;\n    border-radius: 1px;\n  }\n\n  .DS__FIeld__root .DS__FIeld__underline.DS__FIeld__active {\n      background-color: #97ba1e;\n    }\n\n  .DS__FIeld__root .DS__FIeld__field {\n    height: 32px;\n    padding-left: 12px;\n  }\n\n.DS__FIeld__root :focus ~ .DS__FIeld__underline {\n  background-color: #97ba1e;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__FIeld__root",
	"underline": "DS__FIeld__underline",
	"active": "DS__FIeld__active",
	"field": "DS__FIeld__field"
};